<div class="row">
    <div class="form-group col-md-12">
        <div>
            <ag-grid-angular #agGrid style="width: 100%; height: 8.5rem;" class="ag-theme-sg-bootstrap-condensed"
                [columnDefs]="columnDefs" [rowData]="eCashPaymentsRowData" (gridReady)="onGridReady($event)"
                rowSelection="single" [gridOptions]="gridOptions!">
            </ag-grid-angular>
        </div>
    </div>
</div>